const alignLeftIcon = '<i class="sym sym-align-left" aria-hidden="true"></i>';
const alignCenterIcon = '<i class="sym sym-align-center" aria-hidden="true"></i>';
const alignRightIcon = '<i class="sym sym-align-right" aria-hidden="true"></i>';
const alignJustifyIcon = '<i class="sym sym-align-justify" aria-hidden="true"></i>';
const backgroundIcon = '<i class="sym sym-brush" aria-hidden="true"></i>';
const blockquoteIcon = '<i class="sym sym-quote" aria-hidden="true"></i>';
const boldIcon = '<i class="sym sym-bold" aria-hidden="true"></i>';
const cleanIcon = '<i class="sym sym-clean" aria-hidden="true"></i>';
const codeIcon = '<i class="sym sym-code-02" aria-hidden="true"></i>';
const colorIcon = '<i class="sym sym-text-color" aria-hidden="true"></i>';
const directionLeftToRightIcon = '<i class="sym sym-paragraph" aria-hidden="true"></i>';
const directionRightToLeftIcon = '<i class="sym sym-paragraph" aria-hidden="true"></i>';
const formulaIcon = '<i class="sym sym-function" aria-hidden="true"></i>';
const headerIcon = '<i class="sym sym-heading-1" aria-hidden="true"></i>';
const header2Icon = '<i class="sym sym-heading-2" aria-hidden="true"></i>';
const header3Icon = '<i class="sym sym-heading-3" aria-hidden="true"></i>';
const header4Icon = '<i class="sym sym-heading-4" aria-hidden="true"></i>';
const header5Icon = '<i class="sym sym-heading-5" aria-hidden="true"></i>';
const header6Icon = '<i class="sym sym-heading-6" aria-hidden="true"></i>';
const italicIcon = '<i class="sym sym-italic" aria-hidden="true"></i>';
const imageIcon = '<i class="sym sym-image-02" aria-hidden="true"></i>';
const indentIcon = '<i class="sym sym-right-indent" aria-hidden="true"></i>';
const outdentIcon = '<i class="sym sym-left-indent" aria-hidden="true"></i>';
const linkIcon = '<i class="sym sym-link" aria-hidden="true"></i>';
const listBulletIcon = '<i class="sym sym-dot-list" aria-hidden="true"></i>';
const listCheckIcon = '<i class="sym sym-check-list" aria-hidden="true"></i>';
const listOrderedIcon = '<i class="sym sym-number-list" aria-hidden="true"></i>';
const subscriptIcon = '<i class="sym sym-subscript" aria-hidden="true"></i>';
const superscriptIcon = '<i class="sym sym-superscript" aria-hidden="true"></i>';
const strikeIcon = '<i class="sym sym-strikethrough" aria-hidden="true"></i>';
const tableIcon = '<i class="sym sym-table" aria-hidden="true"></i>';
const underlineIcon = '<i class="sym sym-underline" aria-hidden="true"></i>';
const videoIcon = '<i class="sym sym-film" aria-hidden="true"></i>';

const QuillSym =  {
  align: {
    '': alignLeftIcon,
    center: alignCenterIcon,
    right: alignRightIcon,
    justify: alignJustifyIcon
  },
  background: backgroundIcon,
  blockquote: blockquoteIcon,
  bold: boldIcon,
  clean: cleanIcon,
  code: codeIcon,
  'code-block': codeIcon,
  color: colorIcon,
  direction: {
    '': directionLeftToRightIcon,
    rtl: directionRightToLeftIcon
  },
  formula: formulaIcon,
  header: {
    '1': headerIcon,
    '2': header2Icon,
    '3': header3Icon,
    '4': header4Icon,
    '5': header5Icon,
    '6': header6Icon
  },
  italic: italicIcon,
  image: imageIcon,
  indent: {
    '+1': indentIcon,
    '-1': outdentIcon
  },
  link: linkIcon,
  list: {
    bullet: listBulletIcon,
    check: listCheckIcon,
    ordered: listOrderedIcon
  },
  script: {
    sub: subscriptIcon,
    super: superscriptIcon
  },
  strike: strikeIcon,
  table: tableIcon,
  underline: underlineIcon,
  video: videoIcon
};

export default QuillSym;
//# sourceMappingURL=icons.js.map
